import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';

import './CadeAnalyze.css';

const CadeAnalyzePie = (props) => {
    if (props.pieData.length == 0) {
        return null;
    }

    return (
        <ResponsiveContainer height={props.height}>
            <PieChart>
                <Pie data={props.pieData} dataKey="value" nameKey="name" labelLine={false} cy={100} fill="#F9922C" label >
                    {
                        props.pieData.map((entry, index) => <Cell fill={props.pieColors[index % props.pieColors.length]} />)
                    }
                </Pie>
                <Legend />
            </PieChart>
        </ResponsiveContainer>   
    );
}

export default CadeAnalyzePie;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeAnalyzePie.js